import { checkAdBlockerActive } from './AdBlockerService';
import wait from '../utilities/wait';
import waitDomReady from '../utilities/waitDomReady';

const findTargets = async (): Promise<Element[]> => {
    await waitDomReady();
    return Array.from(document.querySelectorAll('[data-adobe-target]'));
};

const isElementEmpty = element => element.childNodes.length === 0;

const toggleTargetDisplay = (targetElement: Element, fallbackElement: Element, showTarget: boolean) => {
    if (showTarget) {
        targetElement.classList.remove(`adobe-target-content`);
        fallbackElement.remove();
    } else {
        targetElement.remove();
        fallbackElement.classList.remove('adobe-target-fallback');
    }
}

/**
 * Resolves Adobe Targets in Markdown/Markup components
 * Uses this format:
 *
 * <div data-adobe-target="[delayMiliseconds]">
 *    <div id="[id]" class="adobe-target-content"></div>
 *    <div class="adobe-target-fallback">[fallback-content]</div>
 * </div>
 *
 * - [id]: any id selected by users
 * - [delayMiliseconds]: max waiting before fallback content is shown
 * - [fallback-content]: html to be shown if abobe content is not loaded in time
 *
 * Notes: <div> can be changed with other tags like <a>, <span>, <section>, etc
 */
export const applyAdobeTargets = async () => {
    const targets = await findTargets();
    const adBlockerActive = await checkAdBlockerActive();
    targets.forEach(async target => {
        const targetElement = target.querySelector(".adobe-target-content"),
            fallbackElement = target.querySelector(".adobe-target-fallback"),
            delay = Number(target.getAttribute('data-adobe-target'));

        if (!targetElement || !fallbackElement) {
            return;
        }

        if (delay === 0 || isNaN(delay)) {
            toggleTargetDisplay(targetElement, fallbackElement, false);
            return;
        }

        if (!adBlockerActive) {
            await wait(delay);
        }

        if (isElementEmpty(targetElement)) {
            toggleTargetDisplay(targetElement, fallbackElement, false);
        } else {
            toggleTargetDisplay(targetElement, fallbackElement, true);
        }
    });
};